module.exports = __webpack_public_path__ + "static/media/arrow_blue.3cdaac64.svg";